import React, { useState, useEffect, useRef } from 'react'
import { X } from 'react-feather'
import ConfirmationModal from 'app/theme/ConfirmationModal'
import styles from './LeadHeader.module.css'

export default function LeadHeader({closeAction, steps, step, setStep, data, featureFlags, highestLandedStep}) {
  const [confirmClose, setConfirmClose] = useState(false)
  const [leftGradientVisible, setLeftGradientVisible] = useState(false)
  const [rightGradientVisible, setRightGradientVisible] = useState(false)
  const stepIndex = steps.findIndex(s => s === step)
  const headerScrollRef = useRef(null)

  useEffect(() => {
    if (headerScrollRef.current) {
      // try to put the current step in the center of the scroll container
      const stepPosition = headerScrollRef.current?.querySelector(`p:nth-child(${stepIndex + 1})`)?.offsetLeft
      const scrollContainerCenter = headerScrollRef.current?.clientWidth / 2
      const offset = stepPosition - scrollContainerCenter
      headerScrollRef.current.scrollTo({
        left: offset,
        behavior: 'smooth'
      })
    }

  }, [stepIndex])

  useEffect(() => {
    const element = headerScrollRef?.current
    if (!element) {
      return
    }

    element.addEventListener('scroll', () => {
      setLeftGradientVisible(element.scrollLeft > 100)
      setRightGradientVisible(element.scrollLeft + element.clientWidth < element.scrollWidth - 100)
    })

    return () => {
      element.removeEventListener('scroll', () => {
        setLeftGradientVisible(element.scrollLeft > 100)
        setRightGradientVisible(element.scrollLeft + element.clientWidth < element.scrollWidth - 100)
      })
    }
  }, [headerScrollRef?.current])

  return (
    <div className="bg-white border-b border-blue-300">
      <div className="absolute top-0 right-0 p-1">
        <div className="flex items-center h-full">
          <button
            children={<X className="w-4 text-blue" />}
            className="bg-gray-200 rounded-full h-6 w-6 flex items-center justify-center"
            onClick={() => setConfirmClose(true)}
          />
        </div>
      </div>
      <div className="relative">
        <div className="whitespace-no-wrap pb-12 mt-8 overflow-x-scroll no-scrollbar text-center" ref={headerScrollRef}>
          {leftGradientVisible && <div className="absolute z-10 top-0 bottom-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />}
          <div>
            {steps.map((s, index) => {
              let stepColor = ''
              if (index === stepIndex) {
                stepColor = `text-blue border-blue ${styles.step_blue}`
              } else if (index < stepIndex || index <= highestLandedStep) {
                stepColor = `text-gray-800 border-gray-800 ${styles.step_black}`
              } else {
                stepColor = `text-gray-500 border-gray-500 ${styles.step_gray}`
              }
              return (
                <p 
                  key={s.name} 
                  onClick={() => {
                    if (index < stepIndex || index <= highestLandedStep) {
                      setStep(s)
                    }
                  }}
                  className={[
                    "pb-4 mb-4 inline px-4 border-b relative text-md",
                    stepColor,
                    styles.step
                  ]}
                >
                  {s.label}
                </p>
              )
            })}
          </div>
          {rightGradientVisible && <div className="absolute z-10 top-0 bottom-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />}
        </div>
      </div>

      {confirmClose && (
        <ConfirmationModal
          title = 'Are you sure you want to leave?'
          message = "All your answers will be lost."
          onCancel={() => {
            setConfirmClose(false)
            closeAction()
          }}
          closeModal={() => {
            setConfirmClose(false)
            closeAction()
          }}
          onConfirm={() => {
            setConfirmClose(false)
          }}
        />
      )}
    </div>
  )
}
